import store from '../../store';
import queryParams from '../pageQuery.service';
import pvtrack from '../pvtrack.service';
import {
  userActionInterceptor,
  staticIdDecorator,
} from '../socketIO/user.action.interceptor';
import { createPriceBoard } from './components/lead/index';
import layManager from '../layer.manager';
import { Logger } from '../logger';
import { PanoComponent } from './panoComponent';
import util from '../..//utils/util';
function goVr4sIndex() {
  window.location.href =
    'https://dealercloud.m.autohome.com.cn/vr4s/index?pvareaid=2594229';
}
@staticIdDecorator('PanoComponent')
class krPanoComponent extends PanoComponent {
  constructor(initSettings) {
    super(initSettings);
    this.id = 'krpanoSWFObject';
    this.logger = new Logger('PanoComponent');
    this.core = null;
    this.source = initSettings.source;
    this._sceneList = null;
    this.initSettings = initSettings;
    this.currentHotspot = null;
    this.xmlUrl = initSettings.xmlUrl;
    this.dealerId = initSettings.dealerId;
    this.cityId = initSettings.cityId;
    this.canAutorotate = true;
    this._changescenetype = 0; //0场景切换箭头，1导航缩略图切换
    const self = this;
    self.firstSceneLoadedPromiseResolve = null;
    this.loadedPromise = new Promise(function (resolve) {
      self.firstSceneLoadedPromiseResolve = resolve;
    });
    this.readyPromise = new Promise(function (resolve) {
      util
        .loadScript({
          id: 'tour',
          src: PUBLIC_PATH + '/Pano/tour.js',
          cross: true,
        })
        .then(() => {
          self.embed(resolve);
        });
    });
    window.krpano = this;
  }
  getCore() {
    if (!this.core) {
      this.core = document.getElementById(this.id);
    }
    return this.core;
  }
  Call(_action) {
    const core = this.getCore();
    if (core && core.call) {
      core.call(_action);
    }
  }
  get(_v) {
    const core = this.getCore();
    if (core && core.get) {
      return core.get(_v);
    }
    return null;
  }
  set(_e, _v) {
    const core = this.getCore();
    if (core && core.set) {
      core.set(_e, _v);
    }
  }
  addChangeScene(_name, _ath, _atv, _linkedscene) {
    var jstext =
      'krpano.linkedScene(' +
      _linkedscene +
      ',' +
      _ath +
      ',' +
      _atv +
      ',' +
      _name +
      ')';
    this.Call(
      'addchangescene(' + _name + ',' + jstext + ',' + _ath + ',' + _atv + ')',
    );
  }
  addShowCard(
    _name,
    _seriesid,
    _seriesname,
    _specid,
    _ath,
    _atv,
    loadedAction,
    index,
  ) {
    const modelName = _name;
    this.Call(`addhotspot(${modelName})`);
    const hotspot = `hotspot[${modelName}]`;
    const setProp = (propName, propVal) => {
      this.set(`${hotspot}.${propName}`, propVal);
    };
    setProp('type', 'text');
    setProp('url', '%SWFPATH%/plugins/textfield.swf');
    setProp('renderer', 'css3d');
    setProp('interactivecontent', 'true');
    setProp('ath', _ath);
    setProp('atv', _atv - 7);
    setProp('seriesid', _seriesid);
    setProp('seriesname', _seriesname);
    setProp('specid', _specid);
    setProp('scale', '1');
    setProp('distorted', true);
    setProp('edge', 'top');
    setProp('html', '');
    setProp('specinfo_vrglass', '');
    setProp('width', '240');
    setProp('height', '35');
    setProp('hotspottype', 'showinfocard');
    setProp('vrincarurl', '');
    setProp('zorder', index);
    setProp('backgroundalpha', 0);
    let elementId = `board_${_name}`;
    setProp('html', `<div id="${elementId}"></div>`);
    let hotspotAction = _name + '_action';
    window[hotspotAction] = function () {
      loadedAction(elementId);
      delete window[hotspotAction];
    };
    setProp('onloaded', `js(${hotspotAction}())`);
  }
  setWebvrChangeScene() {
    this.set('hotspot[webvr_next_scene].url', '%SWFPATH%/skin/./vtourskin.png');
    this.set('hotspot[webvr_prev_scene].url', '%SWFPATH%/skin/./vtourskin.png');
  }
  removehotspot(_name) {
    this.Call('removehotspot(' + _name + ')');
  }
  lookatHotspot(_name) {
    if (!_name) {
      return;
    }
    const hostspot = this.get(`hotspot[${_name}]`);
    if (hostspot) {
      this.Call(
        'lookto(' +
          hostspot.ath +
          ',get(view.vlookat),get(view.fov),tween(linear,0.6))',
      );
    }
  }
  autorotate(bool) {
    if (!this.canAutorotate) {
      this.set('autorotate.enabled', false);
      return;
    }
    if (bool === true || bool.toString().toLowerCase() === 'true') {
      this.set('autorotate.enabled', true);
    } else {
      this.set('autorotate.enabled', false);
    }
    this.set('autorotate.waittime', 1.5);
    this.set('autorotate.speed', 1);
    this.set('autorotate.horizon', 0.0);
  }
  autoscale() {
    setTimeout('krpano.autoscale()', 2500);
  }
  preload() {
    store.commit('scene/setCurrentScene', this.get('xml.scene'));
    this.autorotate(true);
    this.Call('removeallhavevrimage()');
    this.Call('skin_showmap(false);');

    try {
      this.autoscale();
      this.initHotspot(this.get('scene[get(xml.scene)].id'));
    } catch (e) {
      console.error('preload', e);
    }
    this.setWebvrChangeScene();
  }
  initHotspot(sceneId) {
    //场景的浏览日志
    store
      .dispatch('scene/getHotSpotList', {
        dealerId: this.dealerId,
        sceneId: sceneId,
        cityId: this.cityId,
      })
      .then((data) => {
        const currentSceneId = this.get('scene[get(xml.scene)].id');
        if (currentSceneId === sceneId) {
          this.bindHotspotList(data);
        }
      });
  }
  @userActionInterceptor({ execTime: 600 })
  linkedScene(scenename, ah, av, hotspotName) {
    this._changescenetype = 0; //0场景切换箭头；1缩略图切换
    if (parseInt(this.get('scene[' + scenename + ']').visualbooth, 10) === 1) {
      layManager.open3dLayer();
    } else {
      this.zoomLinkedScene(scenename, ah, av, hotspotName);
    }
    pvtrack.pvTrackLogger({
      action: 'arhall_scenearrow_click',
      basic: { type: 'click' },
      extend: { channelId: store.state.sales.vrSalesInfo.channelId },
    });
  }

  zoomLinkedScene(sceneName, ath, atv, hotspotName) {
    this._changescenetype = 0; //0场景切换箭头；1缩略图切换
    this.showLoading();
    this.set('ath', ath);
    this.set('atv', atv);
    // screentosphere(mouse.x,mouse.y,ath,atv);
    this.Call(`
    getlooktodistance(d,ath, atv);
    spheretospace(ath, atv, d, x, y, z);
    calc(fh, 160 - view.ty);
    calc(x, x*fh/y);
    calc(z, z*fh/y);
    `);
    const x = this.get('x');
    const z = this.get('z');
    // adjusthlookat(get(ath));
    // tween(view.hlookat, get(ath), 1.0, smooth);
    this.Call(`
    loadscene(${sceneName},image.ox=${x}&image.oz=${z},
      MERGE|KEEPVIEW|KEEPMOVING|KEEPLOOKAT,
      BLEND(0.6)
      );
    `);
    console.log('hotspotName', hotspotName, this.get('d'), ath, atv);
    store.commit('scene/setCurrentScene', sceneName);
  }
  thumbnailClick(sceneName) {
    //added by sujunhui 20191229 点击导航缩略图
    this._changescenetype = 1; //0场景切换箭头；1缩略图切换
    this.Call(
      `loadscene('${sceneName}', null, MERGE, OPENBLEND(1, 0.0, 0.75, 0.05, linear));`,
    );
  }
  adjustFov(near) {
    //added by sujunhui 20191229 调整景深远近
    try {
      if (near === true) {
        this.Call('tween(view.fov, 88, 2,easeOutQuint)');
      } else {
        this.Call('tween(view.fov, 120, 2,easeOutQuint)');
      }
    } catch (e) {
      console.log(e);
    }
  }
  bindHotspotList(hotspots) {
    const visualbooth = this.get('scene[get(xml.scene)].visualbooth') === '1';
    hotspots.forEach((hotspotInfo, index) => {
      const hotspotName = 'hotspot-' + hotspotInfo.Id;
      if (this.get(`hotspot[${hotspotName}]`)) {
        return;
      }
      if (hotspotInfo.Type === 1 && !visualbooth) {
        this.addChangeScene(
          hotspotName,
          hotspotInfo.Ath,
          hotspotInfo.Atv,
          hotspotInfo.NextScene,
        );
      } else if (hotspotInfo.Type === 2) {
        this.addPriceCardHotSpot(hotspotInfo, index);
      }
    });
  }
  addPriceCardHotSpot(hotspotInfo, index) {
    const sceneName = this.get('xml.scene');
    const gdXiaoChengXu = queryParams.from === 'gdxiaochengxu'; // 高德小程序隐藏呼吸点
    if (gdXiaoChengXu) {
      return;
    }
    const seriesName = hotspotInfo.SeriesName;
    const specName = hotspotInfo.SpecName;
    const seriesId = hotspotInfo.SeriesId;
    const specId = hotspotInfo.SpecId;
    if (seriesName && specName) {
      const has3d = hotspotInfo.Has3dModel === 1;
      const loadedAction = (elementId) => {
        createPriceBoard(elementId, {
          hotspotId: hotspotInfo.Id,
          has3d: has3d,
          sceneName: sceneName,
          seriesId: seriesId,
          specId: specId,
          salesInfo: hotspotInfo.SalesInfo,
          seriesName: seriesName,
          specName: specName,
          dealerNewPrice: hotspotInfo.DealerNewPrice,
          maxOriginalPrice: hotspotInfo.MaxOriginalPrice,
          facRebateAmount: hotspotInfo.facRebateAmount || 0,
          downPrice: hotspotInfo.DownPrice || 0,
          score: hotspotInfo.SeriesReputationScore || 0,
          jumpUrl: hotspotInfo.jumpurl || '',
        });
      };
      const hotspotName = 'hotspot-' + hotspotInfo.Id; //车型展示牌
      this.addShowCard(
        hotspotName,
        seriesId,
        seriesName,
        specId,
        hotspotInfo.Ath,
        hotspotInfo.Atv,
        loadedAction,
        index,
      );
      if (this._changescenetype === 1 && hotspotInfo.FirstShow === 1) {
        //如果是点击缩略图，且当前场景有设置第一视角场景展示牌，则镜头自动对准
        setTimeout(() => {
          this.lookatHotspot(hotspotName);
        }, 1000); //延迟1s，对准车型展示牌，留一些添加车型展示牌的时间
      }
    }
  }
  removepano() {
    window.removepano(this.id);
  }
  showtext(_message) {
    this.Call(`showtext('${_message}','showtextstyle')`);
  }
  showLoading(isShow) {
    if (isShow === 'true') {
      store.commit('loading/setLoadStart', { sceneType: 'full' });
    } else {
      store.commit('loading/setLoadComplete', { sceneType: 'full' });
    }
  }
  embed(resolve) {
    var settings = {};
    let titleArg = 'skin_title';
    settings['title'] = '';
    settings[`layer[${titleArg}].visible`] = false;
    try {
      window.embedpano({
        swf: PUBLIC_PATH + '/Pano/tour.swf',
        xml: this.xmlUrl,
        target: 'pano',
        html5: 'only',
        mobilescale: 0.5,
        vars: settings,
        initvars: this.initSettings,
        passQueryParameters: false,
        onready: (_krpano) => {
          this.core = _krpano;
          let events = _krpano.get('events');
          let actions = _krpano.get('action');
          _krpano.set('x', 0);
          _krpano.set('z', 0);
          events.createItem('first_scene_loaded', {
            keep: 'true',
            devices: 'html5',
            onloadcomplete: 'js(krpano.initScene());',
          });
          events.createItem('common_event', {
            keep: 'true',
            devices: 'html5',
            onmousedown: 'js(krpano.startSendPosition());',
            onmouseup: 'js(krpano.stopSendPosition());stopmovements();',
            onidle: 'js(krpano.stopSendPosition());',
            onblendcomplete: ` set(view.tx,0);
            set(view.tz,0);
            set(image.ox,0);
            set(image.oz,0);
                js(krpano.initHotspot(get(scene[get(xml.scene)].id)));
                js(krpano.autorotate(true));
             `,
            onloadcomplete: `jsget(a,"window.krpano._changescenetype");
            if(a===0, tween(view.tx|view.ty|view.tz, calc(x + '|' + 0 + '|' + z), 0.6););
                `,
            onclick: 'js(krpano.sceneClick());',
            onxmlerror: 'js(krpano.logger.error(get(lasterror)))',
            onloaderror: 'js(krpano.logger.error(get(lasterror)))',
          });
          resolve(this);
        },
        onerror: (ex) => {
          this.logger.error('krpano错误' + ex.toString());
          goVr4sIndex();
        },
      });
    } catch (ex) {
      this.logger.error('初始化场景错误' + ex.toString(), ex);
      goVr4sIndex();
    }
    this.core = document.getElementById(this.id);
  }
  startSendPosition() {
    if (!this.posTimer) {
      this.posTimer = setInterval(() => {
        console.log('startSendPosition');
        this.syncScene();
      }, 1000.0 / 30.0);
    }
  }
  stopSendPosition() {
    console.log('stopSendPosition');
    window.clearInterval(this.posTimer);
    this.posTimer = null;
  }
  setPosition(position) {
    const scene = this.get('xml.scene');
    this.Call('stopmovements()');
    if (scene === position.scene) {
      this.set('view.vlookat', position.v);
      this.set('view.hlookat', position.h);
      this.set('view.fov', position.fov);
    } else {
      this.Call(`loadscene(${position.scene},
      null,
      MERGE,
      OPENBLEND(1, 0.0, 0.75, 0.05, linear),
      set(view.vlookat,${position.v});
      set(view.hlookat,${position.h});
      set(view.fov,${position.fov});
      );`);
      store.commit('scene/setCurrentScene', position.scene);
    }
  }
  @userActionInterceptor({ methodName: 'setPosition' })
  sendPosition(position) {
    console.log(position);
  }
  syncScene() {
    const scene = this.get('xml.scene');
    const v = this.get('view.vlookat');
    const h = this.get('view.hlookat');
    const fov = this.get('view.fov');
    this.sendPosition({ scene, h, v, fov });
  }
  initScene() {
    setTimeout(() => {
      // 因为首次加载会默认场景切换问题，需要延迟100ms左右
      this.preload();
    }, 150);
    let events = this.get('events');
    events.removeItem('first_scene_loaded');
    this.firstSceneLoadedPromiseResolve();
  }
  sceneClick() {
    this.emit('scene_clicked');
  }
}

export { krPanoComponent as PanoComponent };
